import { render, staticRenderFns } from "./priceIndexControl.vue?vue&type=template&id=241b6186&scoped=true"
import script from "./priceIndexControl.vue?vue&type=script&lang=js"
export * from "./priceIndexControl.vue?vue&type=script&lang=js"
import style0 from "./priceIndexControl.vue?vue&type=style&index=0&id=241b6186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b6186",
  null
  
)

export default component.exports